/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

import { Stack, Card, Image, Form } from 'react-bootstrap';

import { Titre, ComputeEnv } from '../Fonctions';

/// Environnement
import calme from "../../images/calme.webp";
import bruyant from "../../images/bruyant.webp";
import tres_bruyant from "../../images/tres_bruyant.webp";

function Environnement({ environnement, setEnvironnement, securite }) {
	const debug = false;

	return (
		<Stack gap={2}>
		<Titre>Environnement sonore</Titre>
			<Card style={{ width: '95%' }}>
				<Stack gap={2}>
					<Stack direction='horizontal' gap={4}>
						<Stack>
							<Image src={calme} rounded style={{ width: '20%', display: 'block', margin: 'auto' }} alt='logo-calme'/>
							<p style={{ textAlign: 'center', margin: 'auto' }}>Calme</p>
						</Stack>
						<Stack>
							<Image src={bruyant} rounded style={{ width: '32%', display: 'block', margin: 'auto' }} alt='logo-bruyant'/>
							<p style={{ textAlign: 'center', margin: 'auto' }}>Bruyant</p>
						</Stack>
						<Stack>
							<Image src={tres_bruyant} rounded style={{ width: '20%', display: 'block', margin: 'auto' }} alt='logo-tres-bruyant'/>
							<p style={{ textAlign: 'center', margin: 'auto' }}>Très bruyant</p>
						</Stack>
					</Stack>
					<Form.Range style={{ width: '74%', margin: 'auto' }} value={environnement} min={1} max={3} onChange={(e) => setEnvironnement(parseInt(e.currentTarget.value))}/>
					<span style={{ textAlign: 'center' }}>{ComputeEnv(securite, environnement)[1]}</span>
				</Stack>
			</Card>
			{debug ? environnement : null}{debug ? ComputeEnv(securite, environnement)[0] : null}
		</Stack>
	);
}

export default Environnement;
